import { Box, Button, Typography, useTheme } from "@mui/material";
import copy from "copy-to-clipboard";
import React, { ForwardedRef, forwardRef, useState } from "react";
import { ICompanyDto } from "../../../../types/company";
import BigCompanyIcon from "../../../../media/images/icons/company-big-icon";
import ArrowDownSVG from "../../../../media/images/icons/arrow-down";
import CallOutlineSVG from "../../../../media/images/icons/call-outline";
import CustomButton from "../../../components/CustomButton";
import CopyClipboardIcon from "../../../../media/images/icons/copy-icon";

const CompanyInfoBox = forwardRef(
  (props: ICompanyDto, ref: ForwardedRef<HTMLDivElement>) => {
    const theme = useTheme();
    const [open, setOpen] = useState(false);

    const { address, companyName, tel } = props;

    const [acceptCopy, setAcceptCopy] = useState({
      address: false,
      phoneNumber: false,
    });

    const handleCopyText = (text: string, key: "address" | "phoneNumber") => {
      copy(text);
      setAcceptCopy((prev) => ({ ...prev, [key]: true }));
      const timer = setTimeout(() => {
        setAcceptCopy((prev) => ({ ...prev, [key]: false }));
      }, 2000);
      return () => clearTimeout(timer);
    };

    return (
      <Box
        ref={ref}
        sx={{
          backgroundColor: theme.palette.bgColor.blueGrey50,
          paddingX: "8px",
          borderRadius: "16px",
          marginTop: "16px",
          borderWidth: "1px",
          borderColor: "primary.main",
          borderStyle: "solid",
          display: "flex",
          flexDirection: "column",
          paddingY: "8px",
        }}
      >
        <Box
          onClick={() => setOpen((prev) => !prev)}
          sx={{
            // border: "1px solid gray",
            backgroundColor: open ? "primary.main" : "",
            borderRadius: "10px",
            padding: "12px 8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            //   border: "1px solid gray",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <BigCompanyIcon
              color={
                open ? theme.palette.primary[50] : theme.palette.primary[700]
              }
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: open ? "#fff" : "",
                }}
              >
                نام شرکت
              </Typography>

              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "16px",
                  color: open ? "#fff" : "primary.dark",
                }}
              >
                {companyName}{" "}
              </Typography>
            </Box>
          </Box>
          <ArrowDownSVG
            size={20}
            color={open ? "#fff" : theme.palette.primary.main}
          />
        </Box>
        <Box
          sx={{
            mt: open ? 1 : 0,
            boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2) inset",
            borderRadius: "8px",
            maxHeight: open ? "250px" : "0px",
            paddingY: open ? "8px" : "0px",
            transition: "all 0.3s ease",
            overflow: "hidden",
            paddingX: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Box
              sx={{
                flex: 1,
                padding: "8px",
                borderRadius: "8px",
                backgroundColor: "background.default",
                //   border: "1px solid gray",
                gap: "8px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "3px",
                  }}
                >
                  <CallOutlineSVG
                    size={15}
                    color={theme.palette.primary.dark}
                  />

                  <Typography
                    noWrap
                    sx={{
                      color: "primary.dark",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >
                    تلفن شرکت:
                  </Typography>
                </Box>
                {tel && (
                  <CustomButton
                    onClick={() => handleCopyText(`${tel}`, "phoneNumber")}
                    title={acceptCopy.phoneNumber ? "کپی شد" : "کپی شماره"}
                    bgColor={theme.palette.primary[700]}
                    fSize="12px"
                    gap="6"
                    fWeight="600"
                    px="4px"
                    py="4px"
                    borderRadius="6px"
                    icon1={<CopyClipboardIcon size={18} color={"#fff"} />}
                  />
                )}
              </Box>
              <Typography
                noWrap
                sx={{
                  fontWeight: "700",
                  color: theme.palette.primary[700],
                  fontSize: "14px",
                }}
              >
                {tel || "--------"}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              mt: 1,

              flex: 1,
              padding: "8px",
              borderRadius: "8px",
              backgroundColor: "background.default",
              //   border: "1px solid gray",
              gap: "8px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography>آدرس شرکت:</Typography>
              {address && (
                <CustomButton
                  onClick={() => handleCopyText(`${address}`, "address")}
                  title={acceptCopy.address ? "کپی شد" : "کپی آدرس"}
                  bgColor={theme.palette.primary[700]}
                  fSize="12px"
                  gap="6"
                  fWeight="600"
                  px="4px"
                  py="4px"
                  borderRadius="6px"
                  icon1={<CopyClipboardIcon size={18} color={"#fff"} />}
                />
              )}
            </Box>
            <Typography
              sx={{
                color: "primary.dark",
              }}
            >
              {address || "-------"}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  }
);

export default CompanyInfoBox;
